import script from "./CountDownTimer.vue?vue&type=script&setup=true&lang=js"
export * from "./CountDownTimer.vue?vue&type=script&setup=true&lang=js"

import "./CountDownTimer.vue?vue&type=style&index=0&id=7c09bab0&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c09bab0"]])

export default __exports__